import React from 'react';
import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from "@headlessui/react";

interface Props {
    label: string;
    placeholder?: string;
    type?: string;
    value: any;
    options: { value: any; text: string }[];
    setValue: (value: any) => void;
}

function SelectField(props: Props) {
    const option = props.options.find(item => item.value === props.value);
    return (
        <div className="select-field">
            <div className="label">{props.label}</div>
            <Listbox value={props.value} onChange={props.setValue}>
                <ListboxButton className="picker-button">
                    {option?.text || props.placeholder}
                </ListboxButton>
                <ListboxOptions
                    className="menu-box var(--button-width)"
                    anchor="bottom"
                    transition
                >
                    {
                        props.options.map(item => (
                            <ListboxOption
                                className="menu-item"
                                key={item.value}
                                value={item.value}
                            >
                                {item.text}
                            </ListboxOption>
                        ))
                    }
                </ListboxOptions>
            </Listbox>
        </div>
    );
}

export default SelectField;
